// extracted by mini-css-extract-plugin
export var divider = "_p6-0";
export var systemMessage = "_p6-1";